const cols = [
  {
    title: "Product",
    links: ["60-Word Briefs", "Fact Check Engine", "Source Radar", "Student Notebook"],
  },
  {
    title: "Company",
    links: ["About", "Editorial Policy", "Careers", "Press Kit"],
  },
  {
    title: "Legal",
    links: ["Privacy", "Terms", "Correction Policy"],
  },
];

const Footer = () => (
  <footer data-testid="footer" className="border-t border-[#1E293B] bg-[#070B12]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-12">
      <div className="md:col-span-5">
        <a href="#top" data-testid="footer-logo" className="flex items-center gap-2.5">
          <img src="/logo-icon.png" alt="InNewZ logo" className="h-9 w-9 object-contain" />
          <span className="font-display font-bold text-xl tracking-tight">
            InNew<span className="text-cyan-400">Z</span>
          </span>
        </a>
        <p className="text-sm text-slate-400 leading-relaxed mt-5 max-w-sm">
          Short news. Verified facts. Every language. Built for readers who question everything.
        </p>
        <p className="mt-6 text-[10px] font-mono-x uppercase tracking-widest text-slate-600">
          Truth, delivered in 60 words
        </p>
      </div>
      {cols.map((c) => (
        <div key={c.title} className="md:col-span-2">
          <h4 className="text-xs font-mono-x uppercase tracking-widest text-slate-500">{c.title}</h4>
          <ul className="mt-4 space-y-2.5">
            {c.links.map((l) => (
              <li key={l}>
                <a
                  href="#top"
                  data-testid={`footer-link-${l.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="text-sm text-slate-400 hover:text-cyan-300 transition-colors duration-200"
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-[#1E293B]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-600">
        <span>© 2026 InNewZ. All rights reserved.</span>
        <span className="font-mono-x uppercase tracking-widest">Independent • Unbiased • Verified</span>
      </div>
    </div>
  </footer>
);

export default Footer;
